import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { getShorthandName, isValidUrl } from "../../../utils/Helper";

export const Profile = ({collapsed}) => {
  const {
    userInfo,profile_image
  } = useSelector((state) => state.auth);
  const [isValidProfileImage, setIsValidProfileImage] = useState(false);

  useEffect(()=>{
    if(profile_image){
      setIsValidProfileImage(isValidUrl(profile_image))
    }
  },[profile_image])

  return (
    <Link to="/dashboard/profile" className={`flex flex-col items-center ${collapsed ? "mx-0 my-6":"m-6"}`}>
      {isValidProfileImage && profile_image ? (
        <img
          src={profile_image ?? ""}
          className={`rounded-full ${collapsed ? "w-9 h-9": "w-14 h-14"} border-4 border-link`}
          alt="user"
        />
      ) : (
        <div className={`${collapsed ? "w-9 h-9": "w-14 h-14"} bg-lightPurple rounded-full flex items-center justify-center border-4 border-link shadow-md cursor-pointer`}>
          <span
            className={`text-profile ${
              getShorthandName(userInfo?.name || "").length > 2 ? "text-f12" : "text-f14"
            }`}
          >
            {getShorthandName(userInfo?.name || "")}
          </span>
        </div>
      )}
      <p className={`${collapsed ? "hidden" : "block"} text-center font-semibold text-f14 pt-2 text-slate`}>
        {userInfo?.name ?? ""}
      </p>
      <p className={`${collapsed ? "hidden" : "block"} text-center font-light text-f14 text-slate`}>{userInfo?.email ?? ""}</p>
    </Link>
  );
};
